import type { HTMLAttributes } from 'react';

export function Skeleton({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={[
        'animate-pulse bg-[var(--color-rule)] rounded-[var(--radius-xs)]',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}
